import React from 'react';
import classNames from 'classnames';
import { Modal } from 'react-responsive-modal';
import ButtonWithSpinner from 'components/buttons/ButtonSpinner';
import valUtils from "utils/validations"
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import useAccount from 'hooks/useAccount';

const validationSchema = Yup.object().shape({
    rhpusername: Yup.string().required("Required"),
    rhppassword: Yup.string().required("Required"),
});

const LinkToRHPAccountPopup = (props) => {
    const accountProvider = useAccount();
    const { linkToRHPAccount } = accountProvider;
       
    const {open, close, onSuccess=()=>{} } = props;
    const {
        handleSubmit,
        formState: { errors },
        register,
    } = useForm({
        //mode: 'all',
        defaultValues: {
            rhppassword: '',
            rhpusername: ''
        },
        resolver: yupResolver(validationSchema)
    });

   
    const onSubmitHandler = async (frmData, e) => {
        e.preventDefault();
        if (linkToRHPAccount.isLoading) return;

        const submittedData = { Password: frmData.rhppassword, Username: frmData.rhpusername };

        linkToRHPAccount.mutateAsync(submittedData)
            .then(() => {
                if(onSuccess)
                    onSuccess();
                close();
               
            })
            .catch(() => {}); // error handled by onError in useAccount
    }

    return (
        <Modal classNames={{ overlay: 'verification-overlay', modal: 'verification-modal',}} 
            open={open} 
            onClose={close} 
            center>
            <h2>Link your RedHotPie account</h2>
           
            <form autocomplete="off" className="verification-form" onSubmit={handleSubmit(onSubmitHandler)}>
                <fieldset className="input">
                    <input type="text" name="fake-username" style={{ display: 'none' }} tabIndex={-1} aria-hidden="true" />
                    <input type="password" name="fake-password" style={{ display: 'none' }} tabIndex={-1} aria-hidden="true" />
                     <p className={classNames("confirm-pass", {error: errors?.rhpusername?.message})}>
                        <label htmlFor="confirm-pass" >Username</label>
                        <input   
                            id="confirm-pass" type="text" 
                            placeholder="Enter Username"  
                            {...register("rhpusername")}
                            autoComplete="new-password"
                            />
                        <span className="error-msg">{errors?.rhpusername?.message}</span>
                    </p>
                    
                    <p className={classNames("create-pass", {error: errors?.rhppassword?.message})}>
                        <label htmlFor="create-pass" >Password</label>
                        <input 
                            id="create-pass" 
                            type="password" 
                            placeholder="Enter Password"  
                            {...register("rhppassword")}
                            autoComplete="new-password"
                            />
                        <span className="error-msg">{errors?.rhppassword?.message}</span>
                    </p>
                   
                </fieldset>
                <fieldset className="submit">
                    <p className="btn grey">
                        <ButtonWithSpinner text={`Save`} isLoading={linkToRHPAccount.isLoading} />
                    </p>
                </fieldset>
            </form>
        </Modal>
    );
}

export default LinkToRHPAccountPopup;